/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ParameterMap extends models.ParameterBaseWithSchema {
    constructor() {
        super();
        this.setDiscriminator("ParameterMap");
    }

    getFixupPrototypeFunction() { return ParameterMap.fixupPrototype; }

    static newInstance(model: Partial<ParameterMap>): ParameterMap {
        let obj = Object.assign(new ParameterMap(), model);
        ParameterMap.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ParameterMap>): ParameterMap {
        if (!model) return null;
        return ParameterMap.newInstance(<ParameterMap> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ParameterMap) {
        if (!obj) return;

        models.ParameterMap.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ParameterMap): boolean {
        if (models.ParameterBaseWithSchema.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ParameterMap.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
